import { useEffect } from 'react'
import {
  AnalyticsManager,
  EventActions,
  EventCategories,
  EventNames,
  TrackingEventTypes,
  useAnalytics,
} from '../analytics-manager'
import { zendeskMessengerScriptProps } from '@cinch-labs/shared-zendesk-messenger'

interface AnalyticsWithZendeskProps {
  enableLiveChat?: boolean
}

export const AnalyticsWithZendesk = ({
  enableLiveChat = true,
}: AnalyticsWithZendeskProps) => {
  const { trackEvent } = useAnalytics()

  useEffect(() => {
    const handler = () => {
      trackEvent({
        type: TrackingEventTypes.ADOBE,
        eventName: 'Zendesk chatbot - button clicked',
        data: {
          event: {
            action: EventActions.modalOpened,
            name: EventNames.click,
            category: EventCategories.zendeskChatbot,
            label: 'zendesk-chatbot',
            type: 'support',
          },
        },
      })
    }

    window.addEventListener('zendesk:open', handler)
    return () => window.removeEventListener('zendesk:open', handler)
  }, [trackEvent])

  return (
    <AnalyticsManager
      enableLiveChat={enableLiveChat}
      zendeskChatBotScript={
        <script
          {...zendeskMessengerScriptProps({
            id: 'ze-snippet',
            env: process.env['STAGE_NAME'] || 'development',
          })}
        />
      }
    />
  )
}
